import TrackingSDK from "spark-analytics-sdk";

export const analyticsBridge = {
  init: (...args: Parameters<typeof TrackingSDK.init>) => TrackingSDK.init(...args),
  track: (...args: Parameters<typeof TrackingSDK.track>) => TrackingSDK.track(...args),
  update: (...args: Parameters<typeof TrackingSDK.update>) => TrackingSDK.update(...args),
};

export default analyticsBridge;
